<script>
import { mapActions } from "vuex";
import ApexCharts from "apexcharts";
import { handleColorById } from "../store/handleColor";

export default {
  data() {
    return {
      series: [
        {
          data: [],
        },
      ],
      chartOptions: {
        chart: {
          type: "bar",
          height: 550,
          animations: {
            enabled: false,
          },
          toolbar: {
            show: false,
          }
        },
        labels_data: [],
        colors: [],
        plotOptions: {
          bar: {
            distributed: true,
            horizontal: false,
            columnWidth: "55%",
            endingShape: "rounded",
            dataLabels: {
              position: "bottom"
            }
          },
        },
        dataLabels: {
          enabled: true,
          style: {
            fontSize: "12px"
          }
        },
        legend: {
          formatter: (value, { seriesIndex, w }) => {
            return this.chartOptions.labels_data[seriesIndex];
          },
        },
        stroke: {
          show: true,
          width: 30,
          colors: ["transparent"],
        },
        xaxis: {
          categories: [],
          labels: {
            style: {
              colors: [],
              fontSize: "12px",
              fontWeight: "bold"
            },
          },
          axisTicks: {
            position: 'top',
          }
        },
        title: {
          text: this.language === 'tr' ? 'Dış Paydaş Ortalama Yanıtları (Müşteriler)' : "External Stakeholders Average Answers (Customers)",
          align: "center",
          style: {
            fontSize: "20px",
            heigth: "100px",
            fontFamily: "Muli', Arial, sans-serif",
            cssClass: 'data-labels'
          },
        },
        yaxis: {
          title: {
            text: this.language === 'tr' ? 'Etki Puanı' : 'Impact Rating',
          },
        },
        fill: {
          opacity: 1,
        },
        tooltip: {
          enabled: false,
          y: {
            formatter: function (val) {
              return val;
            },
          },
        },
      },
    };
  },

  mounted() {
    this.getNames();
  },
  props: {
    selectedSurveyID: null,
    language: {
      type: String,
      default: localStorage.getItem('lang') || 'en',
    }
  },
  methods: {
    ...mapActions("results", ["getInternalStakeholderAverageAnswers"]),
    getNames() {
      let params = {
        su2_survey_id: this.selectedSurveyID,
        company_id: this.$user.company_id,
        created_by: this.$user.user_id,
        is_deleted: "false",
        is_approved: "true",
        language: this.language,
      };
      this.getInternalStakeholderAverageAnswers(params)
        .then((response) => {
          response.data.series.forEach((item, index) => {
            this.series[0].data.push(this.formatDataPoint(item.external_customers_average));
            this.chartOptions.labels_data.push(`${(index + 1)}-${item.name}`);
            this.chartOptions.xaxis.categories.push(index + 1);
            this.chartOptions.colors.push(handleColorById(item.category_id));
            this.chartOptions.xaxis.labels.style.colors.push(handleColorById(item.category_id));
          });
        })
        .finally(() => {
          this.renderChart();
        });
    },
    formatDataPoint(value) {
      return value.toFixed(2);
    },
    updateChart() {
      if (this.chart) {
        this.chart.updateSeries(this.series);
      } else {
        this.renderChart();
      }
    },
    renderChart() {
      new ApexCharts(this.$el, {
        chart: this.chartOptions.chart,
        colors: this.chartOptions.colors,
        series: this.series,
        plotOptions: this.chartOptions.plotOptions,
        dataLabels: this.chartOptions.dataLabels,
        legend: this.chartOptions.legend,
        /* stroke: this.chartOptions.stroke, */
        xaxis: this.chartOptions.xaxis,
        yaxis: this.chartOptions.yaxis,
        fill: this.chartOptions.fill,
        tooltip: this.chartOptions.tooltip,
        title: this.chartOptions.title,
      }).render();
    },
  },
};
</script>

<template>
  <div>
    <apexchart type="bar" width="100%" :options="chartOptions" :series="series" />
  </div>
</template>